import { Component, Input } from '@angular/core';
import { ITableColumn } from '../../models/table-column';
import { LsqBaseColumnComponent } from './base-column.component';

@Component({
    selector: 'lsq-spacer-column',
    template: `
        <ng-container [cdkColumnDef]="column.key">
            <th cdk-header-cell *cdkHeaderCellDef [ngStyle]="{ width: width || column.width }"></th>
            <td cdk-cell *cdkCellDef [ngStyle]="{ width: width || column.width }"></td>
            <td cdk-footer-cell *cdkFooterCellDef></td>
        </ng-container>
    `
})
export class LsqSpacerColumnComponent extends LsqBaseColumnComponent {
    @Input() public width: string;
    // If a table has multiple spacers, must pass in a column with unique 'key'.
    @Input() public column: ITableColumn = {
        key: 'spacer',
        width: '1rem'
    };
}
